export default "__VITE_ASSET__DYDrDczu__"